export default __webpack_public_path__ + "static/media/2. Harvard Supplement.5ca34c08.pdf";